const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export function getSupabaseEnvironment(url = process.env.REACT_APP_SUPABASE_URL) {
  if (!url) {
    return {
      label: "UNKNOWN",
      tone: "unknown",
      host: "missing Supabase URL",
      isLocal: false,
      isCloud: false,
    };
  }

  try {
    const parsed = new URL(url);
    const host = parsed.host;
    const isLocal = LOCAL_HOSTS.has(parsed.hostname);
    const isCloud = parsed.hostname.endsWith(".supabase.co");

    if (isLocal) {
      return { label: "LOCAL", tone: "local", host, isLocal: true, isCloud: false };
    }

    if (isCloud) {
      return { label: "PRODUCTION", tone: "cloud", host, isLocal: false, isCloud: true };
    }

    return { label: "UNKNOWN", tone: "unknown", host, isLocal: false, isCloud: false };
  } catch {
    return {
      label: "UNKNOWN",
      tone: "unknown",
      host: "invalid Supabase URL",
      isLocal: false,
      isCloud: false,
    };
  }
}
